/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalReauthSubmissionErrorDetails
 */
export interface PalReauthSubmissionErrorDetails {
    /**
     * 
     */
    platform_message?: string;
}

/**
 * Check if a given object implements the PalReauthSubmissionErrorDetails interface.
 */
export function instanceOfPalReauthSubmissionErrorDetails(value: object): value is PalReauthSubmissionErrorDetails {
    return true;
}

export function PalReauthSubmissionErrorDetailsFromJSON(json: any): PalReauthSubmissionErrorDetails {
    return PalReauthSubmissionErrorDetailsFromJSONTyped(json, false);
}

export function PalReauthSubmissionErrorDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionErrorDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'platform_message': json['platform_message'] == null ? undefined : json['platform_message'],
    };
}

export function PalReauthSubmissionErrorDetailsToJSON(json: any): PalReauthSubmissionErrorDetails {
    return PalReauthSubmissionErrorDetailsToJSONTyped(json, false);
}

export function PalReauthSubmissionErrorDetailsToJSONTyped(value?: PalReauthSubmissionErrorDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform_message': value['platform_message'],
    };
}

